import { Service } from './';

export class SearchCMNDService extends Service {

  static get(cmnd) {
    return this.axios.get(`https://mst.minvoice.com.vn/api/System/SearchCMND?cid=${cmnd}`, { timeout: 3000 }).then(res => res.data);
  }

}